import PropTypes from "prop-types";
import { useState } from "react";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";
import TextField from "@mui/material/TextField";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function DefaultInfoCard({ color, icon, title, description, value, onSave }) {
  const [isEditing, setIsEditing] = useState(false);
  const [tempValue, setTempValue] = useState(value);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSave = () => {
    setIsEditing(false);
    onSave(tempValue);
  };

  const handleCancel = () => {
    setIsEditing(false);
    setTempValue(value);
  };

  return (
    <Card>
      <MDBox p={2} mx={3} display="flex" justifyContent="center">
        <MDBox
          display="grid"
          justifyContent="center"
          alignItems="center"
          bgColor={color}
          color="white"
          width="4rem"
          height="4rem"
          shadow="md"
          borderRadius="lg"
          variant="gradient"
        >
          <Icon fontSize="default">{icon}</Icon>
        </MDBox>
      </MDBox>
      <MDBox pb={2} px={2} textAlign="center" lineHeight={1.25}>
        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
          {title}
        </MDTypography>
        {description && (
          <MDTypography variant="caption" color="text" fontWeight="regular">
            {description}
          </MDTypography>
        )}
        {description && !value ? null : <Divider />}
        {isEditing ? (
          <>
            <TextField
              value={tempValue}
              onChange={(e) => setTempValue(e.target.value)}
              fullWidth
            />
            <MDBox mt={2} display="flex" justifyContent="space-between">
              <MDTypography
                variant="body1"
                fontSize={15}
                color="secondary"
                onClick={handleCancel}
                style={{ cursor: "pointer" }}
              >
                취소
              </MDTypography>
              <MDTypography
                variant="body1"
                fontSize={15}
                color="info"
                onClick={handleSave}
                style={{ cursor: "pointer" }}
              >
                저장
              </MDTypography>
            </MDBox>
          </>
        ) : (
          <MDTypography variant="h5" fontWeight="medium">
            {value}
          </MDTypography>
        )}
        {!isEditing && (
          <MDTypography
            variant="body1"
            fontSize={15}
            color="info"
            onClick={handleEditClick}
            style={{ cursor: "pointer", marginTop: "8px" }}
          >
            수정
          </MDTypography>
        )}
      </MDBox>
    </Card>
  );
}

DefaultInfoCard.defaultProps = {
  color: "info",
  value: "",
  description: "",
};

DefaultInfoCard.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSave: PropTypes.func.isRequired,
};

export default DefaultInfoCard;
